export type RawCell = string | { value?: string | null } | null | undefined;

export const cellText = (cell: RawCell): string => {
  if (cell == null) return '';
  return (typeof cell === 'string' ? cell : String((cell as { value?: string | null }).value ?? '')).trim();
};

export const isNumericText = (text: string): boolean => {
  const cleaned = text.replace(/[^0-9.-]/g, '');
  return cleaned !== '' && !isNaN(parseFloat(cleaned));
};

// The entire text must be a number: optional sign or accounting parentheses, digits with whitespace/apostrophe
// group separators and ./, decimals — unlike isNumericText, which accepts any text containing digits.
export const isPureNumericText = (text: string): boolean => {
  let t = text.trim();
  const paren = /^\((.+)\)$/.exec(t);
  if (paren) t = paren[1].trim();
  t = t.replace(/[\s']/g, '').replace(/^[−–]/, '-').replace(/%$/, ''); // \s covers nbsp/narrow-nbsp; unicode minus/en-dash → '-'
  return /^-?\d+([.,]\d+)*$/.test(t);
};

// sv: Not/Noter, en/da: Note/Notes — note-reference columns hold cross-references, not facts.
export const NOTE_HEADER_RE = /^(not(er)?|notes?)$/;

export const isNoteColumn = (grid: RawCell[][], col: number): boolean => {
  const parts: string[] = [];
  for (let row = 0; row < grid.length; row++) {
    const v = cellText((grid[row] ?? [])[col]);
    if (v && !isNumericText(v)) parts.push(v.toLowerCase());
  }
  return NOTE_HEADER_RE.test(parts.join(' ').trim());
};
